<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <v-card class="pt-7 pb-16" color="#fff">
        <v-row class="px-6">
          <v-col md="6" cols="12">
            <v-text-field
              v-model="model.title"
              outlined
              label="عنوان"
              class="rounded-xl"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="model.unit"
              outlined
              label="واحد"
              class="rounded-xl"
              placeholder="مثال: عدد، درصد"
            ></v-text-field>
          </v-col>
          <v-col class="text-left mt-10" cols="12">
            <v-btn
              :loading="loading"
              @click="create"
              color="positive"
              class="textColor--text sm-font500-16 rounded-xl me-3"
              depressed
              height="48"
              width="230"
            >
              ثبت
            </v-btn>
            <v-btn
              width="230"
              height="48"
              depressed
              color="nagative"
              class="textColor--text sm-font500-16 rounded-xl"
              to="/metrics/list"
            >
              انصراف
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import metrics from "@/Services/modules/metrics";

export default {
  name: "MetricsCreate",
  data() {
    return {
      loading: false,
      model: {
        title: "",
        unit: "",
      },
    };
  },
  methods: {
    create() {
      this.loading = true;
      metrics
        .create(this.model)
        .then(() => {
          this.$router.push("/metrics/list");
          this.$toast.success("با موفقیت انجام شد!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
